module.exports = __webpack_public_path__ + "Wireframes5.png?a02b3cd2db449a5168cba4400eabb090";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Wireframes5.png
// module id = 119
// module chunks = 0